export const DELIVERY_UPS = 1;
export const DELIVERY_PACZKOMAT = 2;
export const DELIVERY_POS = 3;
export const DELIVERY_FOREIGN_UPS = 4;
export const DELIVERY_INPOST = 7;

export const PAYMENT_PAYU = 1;
export const PAYMENT_PAYU_LOAN = 4;
export const PAYMENT_PAYU_PAYPO = 10;
export const CASH_ON_DELIVERY_UPS = 2;
export const CASH_ON_DELIVERY = 5;
export const PAYMENT_WIRETRANSFER = 6;
export const CASH_ON_DELIVERY_INPOST = 9;

export const DELIVERY_DEFAULT = 7;
